<div class="container p-4">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header text-left">
            <h1
          style="font-size: 20px; color: black; font-family: 'Inter', sans-serif;"
        >
     {{data.modalTitle}}
        </h1>
            <button
            mat-dialog-close
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <p>{{ data.modalText }}</p>
          </div>
          <div class="modal-footer d-flex gap-3">
            <button
              type="button"
              class="btn "
              style="background-color: #080b53; color:white"
              data-bs-dismiss="modal"
              (click)="response('no')"
            >
            No
            </button>
            <button
              type="button"
              class="btn "
              style="background-color: #080b53; color:white"
              data-bs-dismiss="modal"
              (click)="response('yes')"
            >
            Yes
            </button>
          </div>
        </div>
    </div>
</div>
